import axios from 'axios'
import notifService from '../../services/notifService'

export const getSegment = async (context, pagination) => {
  return await axios
    .get('/cms/segment', {
      params: pagination
    })
    .then(response => {
      context.commit('getSegment', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })
}

export const listSegment = async (context, pagination) => {
  let res = await axios
    .get('/cms/segment', {
      params: pagination
    })
    .then(response => {
      context.commit('listSegment', response.data.data)
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const addSegment = async (context, val) => {
  return await axios
    .post('/cms/segment/add', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const editSegment = async (context, val) => {
  return await axios
    .put('/cms/segment/edit/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const deleteSegment = async (context, val) => {
  return await axios
    .delete('/cms/segment/delete/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const segmentForm = (context, val) => {
  context.commit('segmentForm', val)
}
